import React, { useState } from "react";

import { useNewGlobalSearchService } from "pages/[tenant]/search/hooks/useNewGlobalSearchService/useNewGlobalSearchService";
import { removeAccents } from "pages/[tenant]/search/utils/searchUtils";

import CircularLoader from "shared/components/atoms/CircularLoader";
import { SearchInput } from "shared/components/atoms/SearchInput";
import { ITagCategory } from "shared/providers/context/types/NewGlobalSearch";
import { ITag } from "shared/providers/context/types/NewGlobalSearch";

import SingleTag from "../../atoms/SingleTag";
import { Empty, SearchInputContainer, TagsSectionContainer } from "./styles";

interface ITagsSectionProps {
  category: ITagCategory;
}

const TagsSection = ({ category }: ITagsSectionProps) => {
  const { isLoading } = useNewGlobalSearchService();

  const [searchTagResult, setSearchTagResult] = useState<ITag[] | null>(null);
  const [tagWasFounded, setTagWasFounded] = useState(true);

  const tagsToList = category?.tags;
  const tagsToIterate = searchTagResult || tagsToList;

  const searchTags = (term: string) => {
    const normalizedTerm = removeAccents(term)?.toLowerCase();

    const result = tagsToList?.filter((item) => {
      const normalizedLabel = removeAccents(item?.label || "")?.toLowerCase();
      return normalizedLabel?.includes(normalizedTerm);
    });

    const haveAuthorsResult = !!result?.length;
    if (haveAuthorsResult) {
      setSearchTagResult(result);
      setTagWasFounded(true);
    } else {
      setSearchTagResult(null);
      setTagWasFounded(false);
    }
  };

  const clearSearchTags = () => {
    setTagWasFounded(true);
    setSearchTagResult(null);
  };

  return (
    <TagsSectionContainer>
      <h3>Filtrar por {category?.name}:</h3>

      <SearchInputContainer>
        <SearchInput
          clearSearchMethod={clearSearchTags}
          searchListMethod={searchTags}
          withSearchAndXIcon
          placeholder="Pesquise por nome"
        />
      </SearchInputContainer>

      <div className="tags-list">
        {tagWasFounded ? (
          tagsToIterate?.map((tag) => <SingleTag tag={tag} key={tag?.id} />)
        ) : (
          <Empty>Nenhuma tag foi encontrada.</Empty>
        )}
      </div>

      {isLoading?.GETTING_TAGS && (
        <div className="loader">
          <CircularLoader />
        </div>
      )}
    </TagsSectionContainer>
  );
};

export default TagsSection;
